import React, { useCallback, useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import SearchInputComponent from "./Common/SearchInputComponent";
import { getCandidateUpdateCompliance } from "../../../services/SubRecruiterService";
import swal from "sweetalert";
import { updateCallSatus } from "../../../services/JobFairService";
import { downloadCSV } from "../../../helpers/dataTableHelper";

function CandidateUpdateCompliance() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [selectedRow, setSelectedRows] = useState([]);
  const [fetch, setFetch] = useState(true);
  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "created_at",
    sort_direction: "DESC",
    status: "",
    // fid: fid ? fid : "",
    keyword: "",
  });

  const tableClm = useMemo(() => {
    return [
      {
        name: "ID",
        selector: (row) => row.candidate_id,
        sortable: true,
        sortField: "candidate_id",
      },
      {
        name: "Name",
        selector: (row) => row.legal_name,
        wrap: true,
        minwidth: "200px",
        sortable: true,
        sortField: "legal_name",
      },
      {
        name: "Email",
        selector: (row) => row.email,
        wrap: true,
        minwidth: "200px",
        sortable: true,
        sortField: "email",
      },
      {
        name: "No. of Reminders",
        selector: (row) => row.reminder_type,
        wrap: true,
        minwidth: "200px",
        sortable: true,
        sortField: "reminder_type",
      },
      {
        name: "Last Reminder Date",
        selector: (row) => row.last_reminder_date,
        wrap: true,
        minwidth: "200px",
        sortable: true,
        sortField: "last_reminder_date",
      },
      {
        name: "Call Status",
        cell: (row) => {
          return (
            <select
              className="form-select"
              onChange={(e) =>
                updateCallSatus({
                  candidate_id: row.candidate_id,
                  call_status: e.target.value,
                }).then((res) => {
                  swal("Success", "Call status updated successfully", "success");
                  fetchUsers(reqParams);
                }).catch((err) => {
                  swal("Error", err?.message, "error");
                })
              }
              defaultValue={row?.call_status}
            >
              <option value="">Select Status</option>
              <option value={"Call 1"}>Call 1</option>
              <option value={"Call 2 (3 Days)"}>Call 2 (3 Days)</option>
              <option value={"Call 3 (7 Days)"}>Call 3 (7 Days)</option>
              <option value={"No Response (15 Days)"}>
                No Response (15 Days)
              </option>
              <option value={"Email Sent"}>Email Sent</option>
            </select>
          );
        },
        width: "200px",
      },
    ];
  }, []);

  const [columns, setColumns] = useState(tableClm);

  const fetchUsers = useCallback(
    (params) => {
      setToggleCleared(!toggleCleared);
      setLoading(true);
      getCandidateUpdateCompliance(params)
        .then((res) => {
          setData(res?.data?.data);
          setTotalRows(res?.data?.totalRecords);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams]);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  const handleSearchText = useCallback(
    (text, isClear = false) => {
      if (text || isClear) {
        setReqParams((state) => {
          return { ...state, keyword: text };
        });
        setFetch(true);
      }
    },
    [setReqParams, setFetch]
  );

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex align-items-center mb-4 flex-wrap">
          <button
            onClick={
              () => 
              downloadCSV(data, "candidate-update-compliance-list-")
            }
            className="btn btn-info btn-sm"
          >
            <i className="fas fa-file-csv ms-1"></i> Export
          </button>
        </div>
        <div className="table-responsive">
          <DataTable
            //className="table display dataTablesCard job-table table-responsive-xl card-table dataTable no-footer"
            columns={columns}
            data={data}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            onChangeRowsPerPage={handlePerRowsChange}
            paginationRowsPerPageOptions={[
              10, 20, 30, 50, 100, 200, 500, 1000, 1500, 2000,
            ]}
            onChangePage={handlePageChange}
            selectableRows
            persistTableHead
            onSelectedRowsChange={({ selectedRows }) => {
              setSelectedRows(selectedRows);
            }}
            clearSelectedRows={toggleCleared}
            onSort={handleSort}
            sortServer
            fixedHeader={true}
            fixedHeaderScrollHeight={"500px"}
            subHeader
            subHeaderComponent={
              <SearchInputComponent
                setFilterText={handleSearchText}
                //removeText={isClear}
              />
            }
          />
        </div>
      </div>
    </div>
  );
}

export default CandidateUpdateCompliance;
